import { ReactElement } from 'react';
import { FloatingToolbar } from 'components/common/FloatingToolbar';
import { useDocumentationBulkActions } from '../hooks/useDocumentationBulkActions';

interface DocumentationDataGridFloatingToolbarProps {
  onMoveSelection: () => void;
}

export function DocumentationDataGridFloatingToolbar({
  onMoveSelection,
}: DocumentationDataGridFloatingToolbarProps): ReactElement {
  const {
    actions,
    selectedItemsAmount,
    clearSelection,
  } = useDocumentationBulkActions({ onMoveSelection });

  const multiSelectedItemsAmount = selectedItemsAmount > 1 ? selectedItemsAmount : 0;

  return (
    <FloatingToolbar
      selectedCount={multiSelectedItemsAmount}
      actions={actions}
      onClearSelection={clearSelection}
    />
  );
}
